import { EntityNotes } from "@modernary/mui/components/note";
import EntityAudits from "@/components/EntityAudits.vue";
import { RouterView, type RouterOptions } from "vue-router";
import { EntityDocuments } from "@modernary/mui/components/document";
import type FinancialAssuranceChildList from "./FinancialAssuranceChildList.vue";
import type ComplianceActionChildList from "./ComplianceActionChildList.vue";

const names = {
  facilities: "Facilities.Facilities",
  list: "Facilities.FacilityList",
  new: "Facilities.FacilityNew",
  base: "Facilities.FacilityBase",
  view: "Facilities.FacilityView,",
  notes: "Facilities.FacilityNotes",
  noteEdit: "Facilities.FacilityNoteEdit",
  noteNew: "Facilities.FacilityNoteNew",
  edit: "Facilities.FacilityEdit",
  tankChildList: "Facilities.FacilityTankChildList",
  complianceActionChildList: "Facilities.FacilityComplianceActionChildList",
  financialAssuranceChildList: "Facilities.FacilityFinancialAssuranceChildList",
  financialAssuranceNew: "Facilities.FacilityFinancialAssuranceNew",
  financialAssuranceEdit: "Facilities.FacilityFinancialAssuranceEdit",
  documents: "Facilities.FacilityDocuments",
  documentEdit: "Facilities.FacilityDocumentEdit",
  documentNew: "Facilities.FacilityDocumentNew",
  audit: "Facilities.FacilityAudit",
};

export { names as facilityRouteNames };

const facilityRoutes: RouterOptions["routes"] = [
  {
    path: "/facilities",
    name: names.facilities,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Facilities",
        },
        component: () => import("@/views/facility/FacilityList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Facility New", isNew: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/facility/FacilityBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Facility View" },
            component: () => import("@/views/facility/FacilityView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Facility Edit", isForm: true },
            component: () => import("@/views/facility/FacilityEdit.vue"),
          },
          {
            path: "tanks",
            name: names.tankChildList,
            meta: { title: "Facility Tanks" },
            component: () => import("@/views/facility/TankChildList.vue"),
          },
          {
            path: "complianceActions",
            name: names.complianceActionChildList,
            meta: { title: "Facility Compliance Actions" },
            component: () => import("@/views/facility/ComplianceActionChildList.vue"),
          },
          {
            path: "financialAssurances",
            name: names.financialAssuranceChildList,
            meta: { title: "Facility Financial Assurances" },
            component: () => import("@/views/facility/FinancialAssuranceChildList.vue"),
          },
          {
            path: "financialAssurances/new",
            name: names.financialAssuranceNew,
            meta: { title: "Facility Financial Assurances New", isForm: true },
            component: () => import("@/views/facility/FinancialAssuranceEdit.vue"),
          },
          {
            path: "financialAssurances/:financialAssuranceId(\\d+)",
            name: names.financialAssuranceEdit,
            meta: { title: "Facility Financial Assurances Edit", isForm: true },
            component: () => import("@/views/facility/FinancialAssuranceEdit.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Facility Notes" },
            component: {
              render: () => <EntityNotes idField="facilityId" routeNamePrefix="Facilities.FacilityNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Facility Note Edit", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Facility Note New", isForm: true },
            component: () => import("@/views/facility/FacilityNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Facility Documents" },
            component: {
              render: () => <EntityDocuments idField="facilityId" routeNamePrefix="Facilities.FacilityDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Facility Document Edit", isForm: true },
            component: () => import("@/views/facility/FacilityDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Facility Document New", isForm: true },
            component: () => import("@/views/facility/FacilityDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Facility Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Facility" />,
            },
          },
        ],
      },
    ],
  },
];
export default facilityRoutes;
